require('expose-loader?BV!../../src/utils/bv');
